const PreorderManager = {
    cachedPreorderMessage: null,
    cachedPreorderMessageHTML: null,
    lastState: null,

    getShippingWidget: function () {
        return document.querySelector('[data-block-id*="estimated_delivery_date"]');
    },

    getDeliveryWidget: function () {
        return document.querySelector('.delivery-widget__theme');
    },

    getBuyButtonsContainer: function () {
        return document.querySelector('buy-buttons');
    },

    isPreorderEnabledProduct: function () {
        return document.querySelector('form.singleProductPreOrderForm') !== null ||
            document.querySelector('form[data-preorder-product-id]') !== null;
    },

    hasPreorderForm: function () {
        return document.querySelector('form.showProductPreorder') !== null;
    },

    hasPreorderMessage: function () {
        return document.querySelector('.gPreorderBottomMessage') !== null;
    },

    getSelectedVariantTitle: function () {
        const checkedInputs = document.querySelectorAll('.variant-picker__option-values input:checked');
        const titles = [];
        checkedInputs.forEach(input => {
            const title = input.getAttribute('data-variant-title');
            if (title) titles.push(title);
        });
        return titles.join(' / ');
    },

    hasSwatchForVariant: function (variantTitle) {
        const swatches = document.querySelectorAll('.item-left-bar-swatch');
        for (const swatch of swatches) {
            const swatchName = swatch.getAttribute('data-name');
            if (variantTitle && swatchName && variantTitle.includes(swatchName)) {
                return swatch;
            }
            if (variantTitle && swatchName && swatchName.includes(variantTitle)) {
                return swatch;
            }
        }
        return null;
    },

    isInStock: function () {
        const preorderBtn = document.querySelector('buy-buttons .gPreorderBtn');
        if (preorderBtn) {
            const activeSwatch = document.querySelector('.item-left-bar-swatch.active');
            if (activeSwatch) {
                const inventory = parseInt(activeSwatch.getAttribute('data-inventory'), 10);
                return inventory > 0;
            }
            return false;
        }

        const buyButton = document.querySelector('buy-buttons button[type="submit"]:not(.gPreorderBtn):not(.gPreorderHidden)');
        if (buyButton) {
            const buttonText = buyButton.textContent?.toLowerCase() || '';
            if (buttonText.includes('sold out') || buttonText.includes('unavailable')) {
                return false;
            }
            if (!buyButton.disabled && buttonText.includes('add to cart')) {
                return true;
            }
        }

        const activeSwatch = document.querySelector('.item-left-bar-swatch.active');
        if (activeSwatch) {
            const inventory = parseInt(activeSwatch.getAttribute('data-inventory'), 10);
            return inventory > 0;
        }

        if (buyButton && !buyButton.disabled) {
            return true;
        }
        
        return false;
    },

    isOnBackorder: function () {
        return this.isPreorderEnabledProduct() && !this.isInStock();
    },

    cachePreorderMessage: function () {
        if (this.cachedPreorderMessageHTML) return;
        if (this.isInStock()) return;

        const msg = document.querySelector('.gPreorderBottomMessage:not(.gPreorderBottomMessage--restored)');
        if (msg) {
            this.cachedPreorderMessageHTML = msg.outerHTML;
        }
    },

    restorePreorderMessage: function () {
        if (!this.isOnBackorder()) return;
        if (this.hasPreorderMessage()) return;
        if (!this.cachedPreorderMessageHTML) return;

        const container = this.getBuyButtonsContainer();
        if (!container) return;

        if (container.querySelector('.gPreorderBottomMessage--restored')) return;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.cachedPreorderMessageHTML;
        const restoredMsg = tempDiv.firstElementChild;

        if (restoredMsg) {
            restoredMsg.classList.add('gPreorderBottomMessage--restored');
            container.appendChild(restoredMsg);
        }
    },

    cleanupRestoredMessage: function () {
        const restoredMsg = document.querySelector('.gPreorderBottomMessage--restored');
        if (!restoredMsg) return;

        const realMsg = document.querySelector('.gPreorderBottomMessage:not(.gPreorderBottomMessage--restored)');

        if (realMsg || this.isInStock()) {
            restoredMsg.style.opacity = '0';
            setTimeout(() => restoredMsg.remove(), 100);
        }
    },

    updateShippingWidget: function () {
        const widget = this.getShippingWidget();
        if (!widget) return;

        const shouldHide = this.isOnBackorder();
        const currentlyHidden = widget.classList.contains('preorder-hidden');

        if (shouldHide && !currentlyHidden) {
            widget.classList.add('preorder-hidden');
            widget.classList.remove('preorder-visible');
        } else if (!shouldHide && currentlyHidden) {
            widget.classList.remove('preorder-hidden');
            widget.classList.add('preorder-visible');
        } else if (!shouldHide && !currentlyHidden && !widget.classList.contains('preorder-visible')) {
            widget.classList.add('preorder-visible');
        }
    },

    updateDeliveryWidget: function () {
        const deliveryWidget = this.getDeliveryWidget();
        if (!deliveryWidget) return;

        const hasPreorderMsg = this.hasPreorderMessage();
        const isOutOfStock = this.isOnBackorder() || !this.isInStock();
        const shouldHide = hasPreorderMsg || isOutOfStock;
        const currentlyHidden = deliveryWidget.classList.contains('preorder-hidden');

        if (shouldHide && !currentlyHidden) {
            deliveryWidget.classList.add('preorder-hidden');
            deliveryWidget.classList.remove('preorder-visible');
        } else if (!shouldHide && currentlyHidden) {
            deliveryWidget.classList.remove('preorder-hidden');
            deliveryWidget.classList.add('preorder-visible');
        } else if (!shouldHide && !currentlyHidden && !deliveryWidget.classList.contains('preorder-visible')) {
            deliveryWidget.classList.add('preorder-visible');
        }
    },

    update: function () {
        this.cachePreorderMessage();
        this.cleanupRestoredMessage();
        this.restorePreorderMessage();
        this.updateShippingWidget();
        this.updateDeliveryWidget();
    },

    scheduleUpdate: function () {
        const self = this;
        requestAnimationFrame(() => {
            self.update();
            setTimeout(() => self.update(), 10);
        });
    },

    injectStyles: function () {
        const style = document.createElement('style');
        style.id = 'preorder-manager-styles';
        style.textContent = `
            .gPreorderBottomMessage,
            .gPreorderBottomMessage--restored {
                transition: opacity 0.1s ease-in-out;
            }
            [data-block-id*="estimated_delivery_date"] {
                transition: opacity 0.1s ease-in-out, max-height 0.1s ease-in-out;
            }
            [data-block-id*="estimated_delivery_date"].preorder-hidden {
                opacity: 0 !important;
                pointer-events: none;
                max-height: 0;
                overflow: hidden;
                margin: 0 !important;
                padding: 0 !important;
            }
            [data-block-id*="estimated_delivery_date"].preorder-visible {
                opacity: 1;
            }
            .delivery-widget__theme {
                transition: opacity 0.1s ease-in-out, max-height 0.1s ease-in-out;
            }
            .delivery-widget__theme.preorder-hidden {
                opacity: 0 !important;
                pointer-events: none;
                max-height: 0;
                overflow: hidden;
                margin: 0 !important;
                padding: 0 !important;
            }
            .delivery-widget__theme.preorder-visible {
                opacity: 1;
            }
        `;
        document.head.appendChild(style);
    },

    init: function () {
        const self = this;


        if (!document.getElementById('preorder-manager-styles')) {
            this.injectStyles();
        }


        self.update();
        setTimeout(() => self.update(), 10);
        setTimeout(() => self.update(), 50);


        document.addEventListener('change', (e) => {
            if (e.target.closest('.variant-picker__option-values')) {
                self.scheduleUpdate();
            }
        });


        const buyButtons = document.querySelector('buy-buttons');
        if (buyButtons) {
            const observer = new MutationObserver(() => self.scheduleUpdate());
            observer.observe(buyButtons, { childList: true, subtree: true, attributes: true });
        }


        const itemsLeftPdp = document.querySelector('.items-left-pdp');
        if (itemsLeftPdp) {
            const swatchObserver = new MutationObserver(() => self.scheduleUpdate());
            swatchObserver.observe(itemsLeftPdp, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });
        }


        const form = document.querySelector('product-form form');
        if (form) {
            const formObserver = new MutationObserver(() => self.scheduleUpdate());
            formObserver.observe(form, { attributes: true, attributeFilter: ['class'] });
        }
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => PreorderManager.init());
} else {
    PreorderManager.init();
}
